import { type HttpClient } from '../useHttpClient';

export const remindNudge =
  (httpClient: HttpClient) => async (id: number | string) => {
    const response = await httpClient.api(`/admin/nudges/${id}/send-reminder`, {
      method: 'POST',
    });

    return { data: response.json };
  };
